import {Component, EventEmitter, Input, Output, ChangeDetectionStrategy} from '@angular/core';
import {BicInputComponent} from '@buildinginformationcloud/bic-ui-components';
import {JsonSchema} from '../schema-form.types';

/**
 * integer/number → numeric input (bic-input type=number), coerced to a number.
 *
 * `type` gebunden statt statisch — Begründung siehe {@link SfInputComponent}.
 */
@Component({
  selector: 'sf-number',
  standalone: true,
  imports: [BicInputComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <bic-input
      class="w-full"
      [type]="'number'"
      [value]="value ?? ''"
      [min]="min"
      [max]="max"
      [placeholder]="placeholder"
      [showX]="false"
      (valueChange)="onChange($event)">
    </bic-input>
  `,
})
export class SfNumberComponent {
  @Input() schema: JsonSchema | null = null;
  @Input() value: any;
  @Output() valueChange = new EventEmitter<any>();

  get min(): number {
    return this.schema?.minimum as number;
  }

  get max(): number {
    return this.schema?.maximum as number;
  }

  get placeholder(): string {
    return this.schema?.['x-placeholder'] ?? 'Zahl eingeben…';
  }

  onChange(raw: any): void {
    if (raw === '' || raw === null || raw === undefined) {
      this.valueChange.emit(null);
      return;
    }
    const num = Number(raw);
    this.valueChange.emit(Number.isNaN(num) ? null : num);
  }
}
